import { bookingInquiryApis } from '@apis/dashboard/bookingInquiryApis';
import { createUseQuery } from '@hooks/createUseQuery';

export const useBookingInquiryDetailByD2dNo = createUseQuery(
  (d2dNo: string) => [`/dashboard/booking-inquiry/${d2dNo}/`],
  (d2dNo) => async () => {
    const response = await bookingInquiryApis.get('/dashboard/booking-inquiry/{d2d_no}/', {
      path: { d2d_no: d2dNo },
    });

    return response[200]!;
  },
);
